// extracted by mini-css-extract-plugin
export var addButton = "_f3-0";
export var border = "_f3-8";
export var check = "_f3-h";
export var danger = "_f3-6";
export var dropdownContainer = "_f3-1";
export var editModalBody = "_f3-j";
export var footerContainer = "_f3-i";
export var fullWidth = "_f3-a";
export var hide = "_f3-9";
export var icon = "_f3-3";
export var input = "_f3-7";
export var inputFlex = "_f3-b";
export var inputWrapper = "_f3-c";
export var manualFocus = "_f3-5";
export var optionButton = "_f3-4";
export var pillWrapper = "_f3-e";
export var pointer = "_f3-2";
export var showOverflow = "_f3-f";
export var tagsFlex = "_f3-d";
export var xButton = "_f3-g";